import { SNIPPET_TYPES } from 'drapcode-constant';
import React, { Component, Fragment } from 'react';
import cookie from 'react-cookies';
class TemplateDetail extends Component {
  getTemplateIcon = (snippetType) => {
    switch (snippetType) {
      case SNIPPET_TYPES.MODAL:
      case SNIPPET_TYPES.FLOATING_MODAL:
        return 'webconnect webconnect-files-alt';
      case SNIPPET_TYPES.SNIPPET:
        return 'webconnect webconnect-layout-text-window-reverse';
      case SNIPPET_TYPES.SUB_PAGE:
        return 'webconnect webconnect-file-earmark-richtext';
      case SNIPPET_TYPES.PDF_TEMPLATE:
        return 'webconnect webconnect-layout-text-sidebar-reverse';
      default:
        return 'webconnect webconnect-breadcrumb';
    }
  };

  render() {
    const { name, uuid, projectId, uri, template, redirectUrl, snippetType, version } = this.props;
    let token = cookie.load('token');
    if (!token) {
      token = '';
    }
    return (
      <Fragment>
        <a
          href={`${redirectUrl}editor/${version}/v/${projectId}/${uri}/${uuid}?token=${token}`}
          className={`list-group-item list-group-item-action align-items-center `}
          style={{ cursor: 'pointer', float: 'left' }}
        >
          <i className={this.getTemplateIcon(snippetType)}></i>
          &nbsp;{name}
        </a>
      </Fragment>
    );
  }
}

export default TemplateDetail;
